import { LayerContextType } from './constants.js';
import { LayerManagerLayer } from './types.js';
import { Animations } from './Animations.js';
import { Gateway } from './ReactGateway/Gateway.js';
import './ReactGateway/GatewayDest.js';
import './ReactGateway/GatewayProvider.js';
import { GatewayRegistry } from './ReactGateway/GatewayRegistry.js';
import PropTypes from 'prop-types';
import React from 'react';
import { getZIndexFromLayer } from './utils.js';
import invariant from 'invariant';
import { useMediaQuery } from '@doordash/utilities';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var LayerContext = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(LayerContext, _React$PureComponent);

  var _super = _createSuper(LayerContext);

  function LayerContext() {
    _classCallCheck(this, LayerContext);

    return _super.apply(this, arguments);
  }

  _createClass(LayerContext, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        currentLayerContext: this.props.layer,
        currentLayerZIndex: getZIndexFromLayer(this.props.layer)
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children;
          _this$props.layer;
          var props = _objectWithoutProperties(_this$props, ["children", "layer"]);

      return /*#__PURE__*/React.cloneElement(children, props);
    }
  }]);

  return LayerContext;
}(React.PureComponent);

_defineProperty(LayerContext, "childContextTypes", {
  currentLayerContext: LayerContextType,
  currentLayerZIndex: PropTypes.number
});

function renderOnLayer(layer, WrappedComponent) {
  var animationOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  invariant(Object.values(LayerManagerLayer).includes(layer), 'You must provide a target that is in the registry.');
  var _animationOptions$Ani = animationOptions.AnimationType,
      animation = _animationOptions$Ani === void 0 ? Animations.Slide : _animationOptions$Ani;

  var GatewayWrapped = function GatewayWrapped(props) {
    var _props$animation = props.animation,
        animationProp = _props$animation === void 0 ? animation : _props$animation;
    var prefersReducedMotion = useMediaQuery('(prefers-reduced-motion: reduce)');
    var Animation = prefersReducedMotion && animationProp !== Animations.Custom ? Animations.None : animationProp;
    var content;

    if (Animation !== Animations.Custom && Object.values(Animations).includes(Animation)) {
      props.animation;
          var inProp = props["in"],
          enter = props.enter,
          exit = props.exit,
          onExited = props.onExited,
          _animationOptions = props.animationOptions,
          remainingProps = _objectWithoutProperties(props, ["animation", "in", "enter", "exit", "onExited", "animationOptions"]);

      content = /*#__PURE__*/React.createElement(Animation, {
        "in": inProp,
        enter: enter,
        exit: exit,
        onExited: onExited,
        animationOptions: _animationOptions
      }, /*#__PURE__*/React.createElement(WrappedComponent, remainingProps));
    } else {
      content = /*#__PURE__*/React.createElement(WrappedComponent, props);
    }

    return /*#__PURE__*/React.createElement(Gateway, {
      into: layer
    }, /*#__PURE__*/React.createElement(LayerContext, {
      layer: layer
    }, content));
  };

  GatewayWrapped.contextTypes = {
    gatewayRegistry: PropTypes.instanceOf(GatewayRegistry)
  };
  var name = WrappedComponent.displayName || WrappedComponent.name;
  GatewayWrapped.displayName = "GatewayWrapped(".concat(name, ")");
  return GatewayWrapped;
}

export { LayerContext, renderOnLayer as default };
